<template>
    <div class="modal-content">
        <button class="btn-close-news-modal" @click="closeNewsModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <transition name="fade" v-if="this.config[0].loading">
            <div class="news-loading-element">
                <img src="@/assets/images/loader.gif" alt="">
            </div>
        </transition>
        <div class="news-modal-content" :class="{notVisible: this.config[0].notVisible}">
            <div class="col-left">
                <div class="news-modal-top-titles">
                    <h3>{{news.news_modal_title}}</h3>
                    <div class="desc">
                        <p>{{news.news_modal_desc}}</p>
                    </div>
                </div>
                <!-- select month -->
                <div class="news-modal-info-selection-item">
                    <select id="select-month">
                        <option :value="index" v-for="(item, index) in newsData" :key="index">
                            {{item.news_modal_month}}
                        </option>
                    </select>
                    <svg-icon icon-class="calendar" className="icon-calendar"/>
                    <div class="icon-elem">
                        <svg-icon icon-class="down-arrow" className="icon-down-arrow"/>
                    </div>
                </div>
                <!-- end select month -->
                <div class="news-modal-info-list" v-if="this.config[0].visible">
                    <ul>
                        <li v-for="(item, index) in newsData[this.config[0].valueOption].news_modal_list_info" :key="index">
                            <p>{{item.desc}}</p>
                        </li>
                    </ul>
                </div>
                <div class="news-modal-info-desc" v-if="this.config[0].visible">
                    <p>{{newsData[this.config[0].valueOption].news_modal_list_desc}}</p>
                </div>
            </div>
            <div class="col-right">
                <div class="news-info-modal-carousel" v-if="this.config[0].visible">
                    <swiper :options="swiperOption">
                        <swiper-slide 
                            v-for="(slide, index) in newsData[this.config[0].valueOption].news_modal_gallery" :key="index"
                            :style="'background-image:url(' + slide.url + ')'"
                        >
                        </swiper-slide>
                    </swiper>
                    <div class="carousel-navigation carousel-navigation-news">
                        <div class="news-prev-slide slide-btn"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                        <div class="news-next-slide slide-btn"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                    </div>
                    <!-- <div class="swiper-controls news-controls">
                        <div class="news-btn-prev slider-btn slider-btn-prev"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                        <div class="news-btn-next slider-btn slider-btn-next"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsModal',
        props: ['config'],
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    spaceBetween: 20,
                    effect: 'slide',
                    navigation: {
                        nextEl: '.news-next-slide',
                        prevEl: '.news-prev-slide',
                    }
                },
            }
        },
        computed: {
            news () {
                return this.$store.state.news
            },
            newsData() {
                return this.$store.state.newsData
			},
        },
        methods: {
            closeNewsModal() {
                this.$modal.hide('news-modal');
            },
            // initFrame() {
            //     document.getElementById('newsModalPageLoader').classList.add("InitLoader");
            //     document.getElementById('newsModalPageLoaderFrame').classList.add("InitLoader");
            //     document.body.classList.add("InitLoader");
            //     document.getElementById('newsModalPageLoader').classList.add("InitLoaderShow");
            //     document.body.classList.add("showAfterLoader");
            // }
        },
        mounted () {
        }
    } 
</script>

<style lang="scss" scoped>
    @import '@/styles/components/news/news-modal.scss';
    @import '@/styles/components/news/news-respond/news-modal-respond.scss';
</style>